import { render } from "./PriceListsDetail.vue?vue&type=template&id=61f94f1e&scoped=true&ts=true"
import script from "./PriceListsDetail.vue?vue&type=script&lang=ts"
export * from "./PriceListsDetail.vue?vue&type=script&lang=ts"

import "./PriceListsDetail.vue?vue&type=style&index=0&id=61f94f1e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f94f1e"]])

export default __exports__